import React from 'react';

/** 1px horizontal divider with a centre-fade gradient (#FFFFFF → #DFE5EB → #FFFFFF), matching the Figma spec. */
export const GradientDivider: React.FC = () => (
  <div
    style={{
      width: '100%',
      height: '1px',
      background: 'linear-gradient(to right, #FFFFFF, #DFE5EB, #FFFFFF)',
      flexShrink: 0,
    }}
  />
);
